export const PUBLIC_INVITATION_FUNCTION_URL =
  process.env.REACT_APP_PUBLIC_INVITATION_FUNCTION_URL ||
  "https://us-central1-invitations778.cloudfunctions.net/getPublicInvitation";

export const PUBLIC_RSVP_FUNCTION_URL =
  process.env.REACT_APP_PUBLIC_RSVP_FUNCTION_URL ||
  "https://us-central1-invitations778.cloudfunctions.net/submitPublicRsvp";

const postJson = async (url, body) => {
  const response = await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(payload.message || payload.code || "PUBLIC_RSVP_REQUEST_FAILED");
    error.code = payload.code || `HTTP_${response.status}`;
    error.status = response.status;
    throw error;
  }
  return payload;
};

export const loadPublicInvitation = ({ eventId, phoneNumber, countView }) =>
  postJson(PUBLIC_INVITATION_FUNCTION_URL, {
    eventId,
    ...(phoneNumber ? { phoneNumber } : {}),
    ...(countView ? { countView } : {}),
  });

export const submitPublicRsvp = (input) => postJson(PUBLIC_RSVP_FUNCTION_URL, input);

export const createRsvpOperationId = () => {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  return `rsvp-${Date.now()}-${Math.random().toString(36).slice(2, 12)}`;
};
